import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";

interface FilterSheetProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onApply: () => void;
  onCancel: () => void;
  onClear: () => void;
  hasFilters: boolean;
  children: React.ReactNode;
}

export function FilterSheet({
  isOpen,
  onOpenChange,
  onApply,
  onCancel,
  onClear,
  hasFilters,
  children,
}: FilterSheetProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Filters</SheetTitle>
          <SheetDescription>Apply filters to narrow down your results. Click apply when ready.</SheetDescription>
        </SheetHeader>
        <div className="space-y-4 mt-4">{children}</div>
        <div className="flex gap-2 mt-8">
          <Button variant="outline" onClick={onClear} disabled={!hasFilters}>
            <X className="h-4 w-4 mr-2" />
            Clear Filters
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="confirm" onClick={onApply}>
            Apply Filters
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
